const brightRed500Color = '#71070B';

export default brightRed500Color;
